import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Form, Input, Button, Spin, message } from 'antd';

const Panel = Collapse.Panel;
const { TextArea } = Input;
const FormItem = Form.Item;

/* eslint-disable */
class RegistroNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModified: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, dataForm) => {
      if (err) {
        return;
      }
      if (this.props.registryInfo.stato === 'N') {
        this.props.onUpdateNotes(this.props.registryInfo.idRegistro, dataForm.annotazioni)
            .then((response) => {
              console.log('debug 8:', response);
              // TODO: inserire notifiche di antd
              if (response.error) {
                return false;
              }
              message.success('Modifica salvata con successo.');
              return true;
            });
        this.setState({
          isModified: false,
        });
      }
    })
  }

  onChangeCheck = (event) => {
    if (event.currentTarget.value !== this.props.registryInfo.annotazioni) {
      this.setState({
        isModified: true,
      });
    } else {
      this.setState({
        isModified: false,
      });
    }
  }

  checkDisable = () => {
    if (this.props.registryInfo.stato !== 'N') {
      return true;
    }
    return !this.state.isModified;
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const annotazioni = this.props.registryInfo.annotazioni;
    const isDisabled = this.checkDisable();
    const isUneditable = (this.props.registryInfo.stato !== 'N' ? true : false);
    return (
      <Collapse
        defaultActiveKey="notes"
        className="box box-solid box-unimi vmg10"
      >
        <Panel header="Note di Registro" key="notes">
          <Spin
            spinning={this.props.isEditing}
            tip="Caricamento..."
          >
            <Form 
                onSubmit={this.handleSubmit}
                className="simple-form"
            >
              <FormItem className="vmg5-bottom">
                {getFieldDecorator('annotazioni', { initialValue: annotazioni })(
                  <TextArea 
                    onChange={this.onChangeCheck} 
                    readOnly={isUneditable} 
                    rows={2}
                  />
                )}
              </FormItem>
              <FormItem className="vmg5-bottom">
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={isDisabled}
                >
                  Salva
                </Button>
              </FormItem>   
            </Form>
          </Spin>
        </Panel>
      </Collapse>
    );
  }
}
/* eslint-enable */

RegistroNotes.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  onUpdateNotes: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
};

const WrappedRegistroNotes = Form.create()(RegistroNotes);

export default WrappedRegistroNotes;
